import { render, staticRenderFns } from "./BottomGroup.vue?vue&type=template&id=06f7833e&scoped=true&"
import script from "./BottomGroup.vue?vue&type=script&lang=ts&"
export * from "./BottomGroup.vue?vue&type=script&lang=ts&"
import style0 from "./BottomGroup.vue?vue&type=style&index=0&id=06f7833e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f7833e",
  null
  
)

export default component.exports